import {
  KibCallIcon,
  KibEmailFillIcon,
  KibIcon,
  KibLockIcon,
} from '@chewy/kib-icons-react'
import Icon from '@mui/material/Icon'
import classNames from 'classnames'
import type { Nil } from '@pbt/pbt-ui-components'
import { Boop, Sms } from '@pbt/pbt-ui-components/src/icons'

import { ConversationTransport } from '~/api/graphql/generated/types'
import { isPlainTextTransport } from '~/utils/communicationsUtils'

import '@chewy/kib-patterns/dist/styles/kib-icon.css'
import styles from './MessageTypeIcon.module.scss'

const MessageIcons = {
  [ConversationTransport.Email]: KibEmailFillIcon,
  [ConversationTransport.Sms]: Sms,
  [ConversationTransport.LogPhoneCall]: KibCallIcon,
  [ConversationTransport.Boop]: Boop,
}

export interface TransportIconProps {
  messageTransport: ConversationTransport | Nil
}

const MessageTypeIcon = ({ messageTransport }: TransportIconProps) => {
  if (!messageTransport) {
    return (
      <KibIcon
        className={styles.htmlAllowedIcon}
        data-testid="internal-note-icon"
      >
        <KibLockIcon />
      </KibIcon>
    )
  }

  const MessageIcon = MessageIcons[messageTransport]

  if (isPlainTextTransport(messageTransport)) {
    return (
      <Icon
        className={classNames({
          [styles.smsIcon]: messageTransport === ConversationTransport.Sms,
          [styles.boopIcon]: messageTransport === ConversationTransport.Boop,
        })}
        component={MessageIcon}
        data-testid={`${messageTransport}-icon`}
      />
    )
  }

  return (
    <KibIcon
      aria-hidden="true"
      className={styles.htmlAllowedIcon}
      data-testid={`${messageTransport}-icon`}
    >
      <MessageIcon />
    </KibIcon>
  )
}

export default MessageTypeIcon
